import { useEffect, useState } from 'react';
import useTutorialStore from '../stores/tutorialStore';
import { getIsStandalone } from './useIsStandalone';

export default function useTutorialPrompt(tutorialConfig) {
  const module = tutorialConfig?.module;
  const [showPrompt, setShowPrompt] = useState(false);

  const loadProgress = useTutorialStore((s) => s.loadProgress);
  const loaded = useTutorialStore((s) => s.loaded);
  const progress = useTutorialStore((s) => s.progress);
  const isActive = useTutorialStore((s) => s.isActive);
  const startTutorial = useTutorialStore((s) => s.startTutorial);

  useEffect(() => {
    if (!loaded) loadProgress();
  }, [loaded, loadProgress]);

  useEffect(() => {
    if (!module || !loaded || isActive) return undefined;
    const record = progress.get(module);
    if (record && (record.completed || record.dismissed)) return undefined;

    // PWA: do not auto-prompt the tour in the installed app. The
    // "Quick tour?" card overlaps the bottom nav and reads as intrusive
    // on mobile. tutorialStore.startTutorial separately no-ops the launch
    // itself on standalone; this guard suppresses the prompt card so it is
    // not shown as a dead-end. Desktop and browser tabs keep the auto-prompt
    // and the existing seen/dismissed state.
    // getIsStandalone() also checks navigator.standalone, so the auto-prompt is
    // now correctly suppressed on the iOS home-screen PWA too.
    if (getIsStandalone()) return undefined;

    const t = setTimeout(() => setShowPrompt(true), 1000);
    return () => clearTimeout(t);
  }, [module, loaded, progress, isActive]);

  const start = () => {
    setShowPrompt(false);
    if (tutorialConfig) startTutorial(tutorialConfig.module, tutorialConfig.steps);
  };

  const dismiss = () => setShowPrompt(false);

  return { showPrompt, startTutorial: start, dismissTutorial: dismiss };
}
